module.exports = __webpack_public_path__ + "static/media/0222_IMG_LA_BOUCHERIE.32c75cdf.png";